/**
 * Converts radians into degrees
 *
 * @param radians - Angle in radians
 * @returns Angle in degrees
 */
export const convertRadiansToDegrees = (radians) => (radians * (180 / Math.PI));
